import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import PageLoader from '../../../../../../components/PageLoader';
import { selectListItems } from '../../../../../../redux/library/selector';
import { tenantOpenNetworkDomains } from '../../../../../../redux/tenant-open-network-domains/action';
import { selectOpennetworkDomainUpdatedItem, selectTenantOpennetworkDomainsListItems, selectOpennetworkDomainCreatedItem, selectOpennetworkDomainQueryItems } from '../../../../../../redux/tenant-open-network-domains/selector';
import DBNDomainComponent from '../components/dbn-domain.component';

const DBNDomain = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const parmas: any = useParams()
    const listDBNDomainsData = useSelector(selectTenantOpennetworkDomainsListItems)
    const queryDBNDomainData = useSelector(selectOpennetworkDomainQueryItems)
    const createDBNDomainData = useSelector(selectOpennetworkDomainCreatedItem)
    const updateDBNDomainData = useSelector(selectOpennetworkDomainUpdatedItem)
    const [selectedDBNDomain, setSelectedDBNDomain] = useState<any>({
        Name: '',
        IsSubDomain: false,
        ParentDomainId: 0,
        Code: ''
    })

    const listDBNDomains = () => {
        dispatch(tenantOpenNetworkDomains.list({
            url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/catalog/dbn-domains/dbn-fetch`,
            entity: 'tenantOpenNetworkDomains',
            jsonData: {}
        }))
    }

    const queryDBNDomain = (id: Number) => {
        dispatch(tenantOpenNetworkDomains.query({
            url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/catalog/dbn-domains/dbn-fetch-detail`,
            entity: 'tenantOpenNetworkDomains',
            jsonData: {
                Records: [
                    {
                        Id: id
                    }
                ]
            }
        }))
    }

    const handleInnerFormChange: any = (event: any, field: string) => {
        console.log('event: any, field', selectedDBNDomain, event, field)
        setSelectedDBNDomain({ ...selectedDBNDomain, [field]: event })
    }

    useEffect(() => {
        console.log('queryDBNDomainData?.result?.items', queryDBNDomainData?.result?.items)
        if (queryDBNDomainData?.result?.items) {
            setSelectedDBNDomain(queryDBNDomainData?.result?.items)
        }
    }, [queryDBNDomainData])

    useEffect(() => {
        listDBNDomains()
        setSelectedDBNDomain({
            Name: '',
            IsSubDomain: false,
            ParentDomainId: 0,
            Code: ''
        })
        if (parmas?.id > 0) {
            queryDBNDomain(Number(parmas?.id))
        }
    }, [parmas])

    useEffect(() => {
        console.log('selectedDBNDomain', selectedDBNDomain)
    }, [selectedDBNDomain]);

    const handleFormSubmit = async (event: any) => {
        event.preventDefault();
        if (parmas?.id > 0) {
            await dispatch(tenantOpenNetworkDomains.resetAction({ actionType: 'update' }))
            await dispatch(tenantOpenNetworkDomains.update({
                url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/catalog/dbn-domains`,
                entity: 'openNetworkTaxonomies',
                jsonData: {
                    Context: {},
                    Records: [
                        selectedDBNDomain
                    ]
                }
            }))
            back();
        } else {
            await dispatch(tenantOpenNetworkDomains.resetAction({ actionType: 'create' }))
            await dispatch(tenantOpenNetworkDomains.create({
                url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/catalog/dbn-domains`,
                entity: 'openNetworkTaxonomies',
                jsonData: {
                    Records: [
                        selectedDBNDomain
                    ]
                }
            }))
            back();
        }
    }

    // useEffect(() => {
    //     console.log('listDBNDomainsData', listDBNDomainsData)
    // }, [listDBNDomainsData]);

    const back = () => {
        navigate(-1)
    }

    return (
        <>
            {listDBNDomainsData?.isLoading ||
                queryDBNDomainData?.isLoading ||
                createDBNDomainData?.isLoading ||
                updateDBNDomainData?.isLoading ? <PageLoader /> :
                selectedDBNDomain && <DBNDomainComponent
                    handleInnerFormChange={handleInnerFormChange}
                    selectedDBNDomain={selectedDBNDomain}
                    domains={listDBNDomainsData?.result?.items}
                    back={back}
                    handleFormSubmit={handleFormSubmit}
                    id={parmas?.id}
                />
            }
        </>
    )
}

export default DBNDomain;